import React, { useState } from 'react'
import { Button, CircularProgress, Grid, Paper } from '@material-ui/core'
import { Field, Form } from 'react-final-form'
import { Search } from '@material-ui/icons'
import { MaskedField } from 'elentari'
import { placaRegex } from '../../../utils/regex'
import api from '../../../services/Api'
import { BRAND } from '../../../branding'
const ProcuraFicha = ({ setFicha, setMessage }) => {
  const [fetching, setFetching] = useState(false)

  const fetchData = async data => {
    setFetching(true)
    if (!data.placa) {
      setMessage('Insira uma placa para fazer a pesquisa')
      setFetching(false)
    } else {
      const response = await api.solicitacaoCargaKmm(data.placa.toUpperCase())
      if (response.ok) {
        if (response.data) {
          setFicha(response.data)
        }
      } else {
        setMessage('Não foi encontrado registro com essa placa')
      }
      setFetching(false)
    }
  }
  return (
    <Grid item xs={12}>
      <Form onSubmit={fetchData}>
        {({ handleSubmit }) => (
          <Paper style={{ padding: 30 }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <img src={BRAND.logo} alt={BRAND.name} />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item sm={10} xs={10}>
                      <Field
                        name="placa"
                        label="Placa"
                        mask={placaRegex}
                        fullWidth
                        component={MaskedField}
                      />
                    </Grid>
                    <Grid item sm={2} xs={2}>
                      <Button type="submit" color="primary" disabled={fetching}>
                        {fetching ? <CircularProgress size={24} /> : <Search />}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={4} xs={12}>
                  {' '}
                </Grid>
              </Grid>
            </form>
          </Paper>
        )}
      </Form>
    </Grid>
  )
}
export default ProcuraFicha
